import * as React from 'react';
import HTMLWrapperEntry from './HTMLWrapperEntry/HTMLWrapperEntry';
import ImageWrapperEntry from './ImageWrapperEntry/ImageWrapperEntry';
import TableEntry from './TableEntry/TableEntry';
import ButtonEntry from './ButtonEntry/ButtonEntry';
import { FAQComponent } from './FAQs';
import { ReactComponentEntry } from './ReactComponentEntry/ReactComponentEntry';

type EmbeddedEntryProps = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    nodeData: Record<string, any>;
};

const CONTENTTYPES = {
    HTMLWRAPPER: 'htmlWrapper',
    BASICTABLE: 'basicTable',
    IMAGEWRAPPER: 'imageWrapper',
    BUTTON: 'button',
    FAQ: 'faq',
    REACTCOMPONENTWRAPPER: 'reactComponent'
};

const EmbeddedEntry: React.FC<React.PropsWithChildren<EmbeddedEntryProps>> = ({
    nodeData
}) => {
    const contentTypeForEntry =
        nodeData?.data?.target?.sys?.contentType?.sys?.id;

    const faqs = nodeData?.data?.target?.fields;

    switch (contentTypeForEntry) {
        case CONTENTTYPES.HTMLWRAPPER:
            return <HTMLWrapperEntry nodeData={nodeData} />;
        case CONTENTTYPES.BASICTABLE:
            return <TableEntry nodeData={nodeData} />;
        case CONTENTTYPES.IMAGEWRAPPER:
            return <ImageWrapperEntry nodeData={nodeData} />;
        case CONTENTTYPES.BUTTON:
            return <ButtonEntry nodeData={nodeData} />;
        case CONTENTTYPES.FAQ:
            return <FAQComponent faqs={faqs} />;
        case CONTENTTYPES.REACTCOMPONENTWRAPPER:
            return <ReactComponentEntry nodeData={nodeData?.data?.target} />;
        default:
            return (
                <div>
                    <p>
                        Unsupported content type. Please select a valid content
                        type.
                    </p>
                </div>
            );
    }
};

export default EmbeddedEntry;
